<app-item-content [row]="row" [startLabel]="startLabel" [endLabel]="endLabel"></app-item-content>
